import { render } from "./BookingAside.vue?vue&type=template&id=3ba8eb22"
import script from "./BookingAside.vue?vue&type=script&lang=js"
export * from "./BookingAside.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingAside.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ba8eb22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ba8eb22', __exports__)) {
    api.reload('3ba8eb22', __exports__)
  }
  
  module.hot.accept("./BookingAside.vue?vue&type=template&id=3ba8eb22", () => {
    api.rerender('3ba8eb22', render)
  })

}


export default __exports__